import React from 'react';
import styled, {keyframes} from 'styled-components';
import {interceptProps} from '@/styled-components';
import {palette} from '@/styles/palette';
import {Typography} from './Typography';

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string;
  size?: number;
  borderSize?: number;
  color?: string;
}

export const LoadingBar = ({
  text,
  size = 36,
  borderSize = 2,
  color = palette.textPrimary,
  ...props
}: IProps) => {
  return (
    <Root {...props}>
      <Spinner size={size}>
        <Inner borderSize={borderSize} color={color}>
          <div />
        </Inner>
      </Spinner>
      {!!text?.length && (
        <Typography variant="medium16" fontWeight="700" as="div">
          {text}
        </Typography>
      )}
    </Root>
  );
};

const spin = keyframes`
  0% {
    transform: translate(-50%,-50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%,-50%) rotate(360deg);
  }
`;

const Root = styled.div`
  text-align: center;
  ${Typography} {
    margin-top: 18px;
  }
`;

const Spinner = styled('div').withConfig({
  shouldForwardProp: interceptProps(['size']),
})<{
  size?: number;
}>`
  ${({size}) => `
    width: ${size}px;
    height: ${size}px;
  `}
  margin: 0 auto;
  overflow: hidden;
`;

const Inner = styled('div').withConfig({
  shouldForwardProp: interceptProps(['borderSize', 'color']),
})<{
  borderSize?: number;
  color?: string;
}>`
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
  & > div {
    position: absolute;
    width: 100%;
    height: 100%;
    ${({borderSize, color}) => `border: ${borderSize}px solid ${color};`}
    border-top-color: transparent;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
    top: 50%;
    left: 50%;
  }
`;
